import React from "react";
import styled from "styled-components";
import {Clickable} from "./Clickable";
import LoggingLink from "./LoggingLink";

const Container = styled(Clickable)`
    max-width: fit-content;
    flex-grow: 1;
    height: 32px;
`;

const BackToAuthorHomepageLink = styled(LoggingLink)`
    color: inherit;
    display: flex;
    text-decoration: none;
    flex-grow: 0;
    flex-shrink: 0;
    align-items: center;
    padding-left: 3px;
    padding-right: 6px;
`;

const ArrowContainer = styled.div`
    padding-top: 1px;
`;

const BackArrow = styled.div`
    flex-grow: 0;
    width: 2px;
    height: 2px;
    
    border-style: solid;
    border-color: inherit;
    border-width: 0 2px 2px 0;
    padding: 1px;
    transform: rotate(135deg);
`;

const BackToHomeButton = styled.div`
    font-size: 14px;
    padding-left: 3px;
`;

const BackToPage = ({path, destinationPage}) => (
    <Container>
        <BackToAuthorHomepageLink to={path} className={`t-back-to-${destinationPage}`}>
            <ArrowContainer>
                <BackArrow/>
            </ArrowContainer>
            <BackToHomeButton>{`BACK TO ${destinationPage}`}</BackToHomeButton>
        </BackToAuthorHomepageLink>
    </Container>
);

export default BackToPage;